'use strict';

const _=require('pulsar-utils/dist-es6/_');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const Entity=require('pulsar-utils/dist-es6/domain/entity');let

GroupVisibilitySettings=class GroupVisibilitySettings extends Entity{
constructor(userId,visibleGroupIds,id){
super(id);

this._userId=userId;
this.visibleGroupIds=visibleGroupIds;
}

get userId(){
return this._userId;
}

get visibleGroupIds(){
return this._visibleGroupIds;
}

set visibleGroupIds(visibleGroupIds){
if(_.exists(visibleGroupIds)){
for(const id of visibleGroupIds){
_.ensureInstanceOf(Guid,id,{nullable:!0});
}
}else if(visibleGroupIds!==null){
throw new Error(`visibleGroupIds must either be an array of Guids (optionally containing null for org group) or null to indicate to use org default settings, got: "${visibleGroupIds}"`);
}

this._visibleGroupIds=visibleGroupIds;
}

toJSON(){
return{
id:this._id.toString(),
userId:this._userId.toString(),
visibleGroupIds:_.exists(this._visibleGroupIds)?
this._visibleGroupIds.map(id=>id===null?null:id.toString()):
null};

}

static fromJSON(jsonSettings){
return new GroupVisibilitySettings(
Guid.fromString(jsonSettings.userId),
_.exists(jsonSettings.visibleGroupIds)?
jsonSettings.visibleGroupIds.map(id=>id===null?null:Guid.fromString(id)):
null,
Guid.fromString(jsonSettings.id));

}

static makeWithDefaultSettings(userId,hideAllGroupsByDefault){
_.ensureInstanceOf('boolean',hideAllGroupsByDefault);
return new GroupVisibilitySettings(userId,hideAllGroupsByDefault?[]:null);
}};


module.exports=GroupVisibilitySettings;
//# sourceMappingURL=groupVisibilitySettings.js.map
